import {httpCall, httpMethod} from "../../service";
import {showlog} from "../../utils";
import {AppSettings, DEFAULT_APP_SETTINGS} from "./static";

export async function loadAppSettings(): Promise<AppSettings> {
	try {
		const result = await httpCall(httpMethod.GET, `mobileagent/app-settings`);
		return {...DEFAULT_APP_SETTINGS, ...(result?.data || {})};
	} catch (e) {
		showlog("error in loadAppSettings()", e);
		return DEFAULT_APP_SETTINGS;
	}
}

export async function saveAppSettings(settings: AppSettings): Promise<AppSettings> {
	try {
		const result = await httpCall(httpMethod.POST, `mobileagent/app-settings`, settings);
		return {...DEFAULT_APP_SETTINGS, ...(result?.data || {})};
	} catch (e) {
		showlog("error in saveAppSettings()", e);
		throw e;
	}
}
